// extracted by mini-css-extract-plugin
export var progressBar = "_jx-0";
export var progressBarInner = "_jx-1";